module.exports = __webpack_public_path__ + "static/media/white-bulb.fdd72069.jpg";